import React from 'react';
import OrgSurveyRow from './OrgSurveyRow/index';

const OrgSurveyList = ({ selectedOrg, onSaveOrgSurvey, showOrgSurveyLoader, surveys }) => {
    return (
        <div className="app-main-content">
            {selectedOrg ?.surveys ? selectedOrg.surveys.map((data, index) =>
                <OrgSurveyRow key={index} selectedOrgSurvey={data} surveys={surveys}
                    onSaveOrgSurvey={onSaveOrgSurvey} showOrgSurveyLoader={showOrgSurveyLoader}
                />
            ) : null}
        </div>
    );
};

export default OrgSurveyList;


// WEBPACK FOOTER //
// ./components/Agile/OrgSurvey/OrgSurveyList/index.js